// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__7ER6A","range":"MonthRangeSwitch_range__OGAvJ","disabled":"MonthRangeSwitch_disabled__2AsLJ"};